import type { LucideIcon } from 'lucide-react';
import { AppWindow, Bell, Hexagon, Home, ListOrdered, Percent, Settings, ShieldAlert, Store, User, Users, Wallet } from 'lucide-react';
import { PAGE } from '@kioskgaming/ui';

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  matchPrefix?: string;
  primary?: boolean;
};

export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: PAGE.dashboard, icon: Home, end: true, primary: true },
  { to: '/agents', label: PAGE.agents, icon: Users, primary: true },
  { to: '/shops', label: PAGE.shops, icon: Store, primary: true },
  { to: '/players', label: PAGE.players, icon: User, primary: true },
  { to: '/transactions', label: PAGE.creditTransactions, icon: ListOrdered, primary: false },
  { to: '/cash-transactions', label: PAGE.cashTransactions, icon: Hexagon, matchPrefix: '/cash-transactions', primary: false },
  { to: '/online-transactions', label: PAGE.usdWalletTransactions, icon: Wallet, primary: false },
  { to: '/provider-fees', label: PAGE.feeConfiguration, icon: Percent, primary: false },
  { to: '/fraud-indicators', label: PAGE.fraudIndicators, icon: ShieldAlert, end: true, primary: false },
  { to: '/popups/send', label: PAGE.popups, icon: AppWindow, end: true },
  { to: '/broadcasts/send', label: PAGE.broadcasts, icon: Bell, end: true },
  { to: '/settings', label: PAGE.settings, icon: Settings, end: true },
];
